// Intersection Observer for scroll animations
const observerOptions = {
  threshold: 0.1,
  rootMargin: '0px 0px -50px 0px'
};

// Fade in + slide up animation
export function initScrollAnimations() {
  const animatedElements = document.querySelectorAll('[data-animate]');
  
  if (!('IntersectionObserver' in window)) {
    // Fallback: show all elements immediately
    animatedElements.forEach(el => {
      el.classList.add('animate-in');
    });
    return;
  }
  
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('animate-in');
        observer.unobserve(entry.target);
      }
    });
  }, observerOptions);
  
  animatedElements.forEach(el => {
    observer.observe(el);
  });
}

// Stagger animation for grid items
export function initStaggerAnimations() {
  const staggerContainers = document.querySelectorAll('[data-stagger]');
  
  staggerContainers.forEach(container => {
    const items = container.querySelectorAll('[data-stagger-item]');
    const delay = parseInt(container.getAttribute('data-stagger-delay') || '100');
    
    items.forEach((item, index) => {
      item.style.setProperty('--stagger-delay', `${index * delay}ms`);
    });
  });
}

// Initialize all animations
export function initAnimations() {
  initScrollAnimations();
  initStaggerAnimations();
}









